import React from "react";
import { SortDirection } from "../../../pages/UnifiedReminderPage/types/sortTypes";
import styles from "./SortIcon.module.scss";

interface SortIconProps {
  direction?: SortDirection;
}

export const SortIcon: React.FC<SortIconProps> = ({ direction }) => {
  return (
    <span className={styles.sortIcon} aria-hidden="true">
      {direction === "asc" && "↑"}
      {direction === "desc" && "↓"}
      {!direction && "↕"}
    </span>
  );
};
